import api from '../auth/api';
import { decryptPayload, formatLabel } from '../../constants/helpers';

export const fetchRiderList = async (setLoaders) => {
    setLoaders(p => ({ ...p, riderFetch: true }));
    try {
        const res = await api.get(`${process.env.REACT_APP_URI}/account/rider-list`);
        if (res.data.success) {
            const decryptedData = decryptPayload(res.data.encryptedData);
            return decryptedData.map(b => ({
                value: b._id,
                label: `${formatLabel(b.employeeRef?.name)}`,
            }));
        }
        return [];
    } catch (e) {
        console.error("Error fetching rider list:", e);
        return [];
    } finally {
        setLoaders(p => ({ ...p, riderFetch: false }));
    }
};